import { Link } from 'react-router-dom';

function ProjectHero({ title, heroImage, heroDescription, headerBackground = '#F7F7F7', logo }) {
  return (
    <section id="hero" className="pt-32 px-6 md:px-12 scroll-mt-32" style={{ backgroundColor: headerBackground }}>
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <Link 
            to="/" 
            className="text-white text-sm font-normal inline-flex items-center gap-2 group"
          >
            <span className="material-symbols-outlined transition-transform duration-300 group-hover:-translate-x-1" style={{ fontSize: '16px' }}>arrow_back</span>
            <span className="group-hover:underline">Back to work</span>
          </Link>
        </div>
        
        <div className="text-center">
          {logo ? (
            <div className="flex justify-center mb-6">
              <img 
                src={logo} 
                alt={title}
                className="h-12 md:h-16 lg:h-20 w-auto object-contain"
              />
            </div>
          ) : (
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-normal text-white leading-tight mb-6">
              {title}
            </h1>
          )}
          
          {/* Description */}
          {heroDescription && (
            <p className="text-lg md:text-xl text-white font-normal max-w-3xl mx-auto leading-relaxed mb-16">
              {heroDescription}
            </p>
          )}

          {/* Project Image */}
          {heroImage && (
            <div className="max-w-2xl mx-auto">
              <div className="flex items-center justify-center overflow-hidden">
                <img 
                  src={heroImage} 
                  alt={title}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default ProjectHero;

